import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
import "./product-details-favorite-modal-note.scss";

// Getters
const $noteElement = document.querySelector(".js-product-details-favorite-modal-note");
const $getModal = () => $noteElement.closest(".modal");
const $getNoteTextSection = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-text");
const $getNoteFormSection = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-form");
const $getNoteErrorMessage = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-error-message");
const $getNoteAddLink = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-add-link");
const $getSubmitButton = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-button-submit");
const $getCancelButton = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-button-cancel");
const $getNoteTextSpan = () =>
  $noteElement.querySelector(".js-product-details-favorite-modal-note-text-content-span");
const $getNoteInput = () => $noteElement.querySelector("#js-note-content-control");
const getNoteTextIsPresented = () => $getNoteTextSpan().textContent !== "";

// Setters
const setNoteLinkText = isNoteTextPresent => {
  $getNoteAddLink().classList.toggle("update", isNoteTextPresent);
};
const setNoteLinkVisibility = isShown => {
  $getNoteAddLink().classList.toggle("hidden", !isShown);
};
const setNoteTextSectionVisibility = isShown => {
  $getNoteTextSection().classList.toggle("hidden", !isShown);
};
const setNoteFormSectionVisibility = isShown => {
  $getNoteFormSection().classList.toggle("hidden", !isShown);
};
const setSubmitButtonDisabled = isDisabled => {
  $getSubmitButton().disabled = isDisabled;
};
const setNoteInput = (inputValue = "") => {
  $getNoteInput().value = inputValue;
};
const setNoteTextSpanContent = (message = "") => {
  $getNoteTextSpan().textContent = message;
};
const setErrorMessage = (message = "") => {
  $getNoteErrorMessage().innerHTML = message;
};

// Actions
const showForm = () => {
  const noteText = $getNoteTextSpan().textContent;

  setNoteInput(noteText);
  setErrorMessage();
  setNoteTextSectionVisibility(false);
  setNoteLinkVisibility(false);
  setNoteFormSectionVisibility(true);
};

const closeForm = () => {
  setNoteLinkText(getNoteTextIsPresented());
  setNoteTextSectionVisibility(getNoteTextIsPresented());
  setNoteLinkVisibility(true);
  setNoteFormSectionVisibility(false);
};

const addNote = () => {
  const $noteInput = $getNoteInput();
  const { productSlug, compositionColor, businessLineId } = $getSubmitButton().dataset;

  setSubmitButtonDisabled(true);
  api.favorites
    .updateFavoriteNote(
      { ac: encodeURIComponent(compositionColor) },
      { product_slug: productSlug, note: $noteInput.value, business_line_id: businessLineId }
    )
    .then(() => {
      setNoteTextSpanContent($noteInput.value.trim());
      closeForm();
    })
    .catch(e => setErrorMessage(e.message))
    .finally(() => {
      setSubmitButtonDisabled(false);
    });
};

const clearNote = () => {
  setNoteTextSpanContent();
  closeForm();
};

// Init
const initHandlers = () => {
  $($getModal()).on("hidden.bs.modal", clearNote);

  $getNoteAddLink().addEventListener("click", showForm);
  $getCancelButton().addEventListener("click", closeForm);
  $getSubmitButton().addEventListener("click", addNote);
};

const initProductDetailsFavoriteModalNote = () => {
  if (!$noteElement) return;
  initHandlers();

  // Update composition color when user changes colors on PDP
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    const $submitButton = $getSubmitButton();
    if ($submitButton) {
      $submitButton.dataset.compositionColor = color;
    }
  });
};

export default initProductDetailsFavoriteModalNote;
